<template>
  <div
    v-if="loading"
    id="loader"
    class="spinner"
  />
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import {mapHelper} from '../mixins/MapMixin'
import {logModes} from "@/components/mixins/VehicleMixin";
import {inject} from "vue";

export default {
    name: 'MapWorkRoadSnapshotV2',
    mixins: [restApi, timeUtils, mapHelper, logModes],
    props: {
        roadOwner: null,
        selectedTaskType: {
            type: Number,
            default: null
        },
        selectedTaskTypes: {
            type: Array,
            default() {
                return []
            }
        },
        selectedOrder: {
            type: Number,
            default: null
        },
        selectedContractId: {
            type: Number,
            default: null
        },
        fromDate: {
            type: String,
            default: null
        },
        toDate: {
            type: String,
            default: null
        },
        selectedContractIds: {
            type: Array,
            default() {
                return []
            }
        },
        map: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            results: [],
            fromTime: null
        }
    },
    watch: {
       map() {
           this.updateSnapshot()
       },
       selectedContractId() {
          this.updateSnapshot()
       },
       selectedContractIds() {
          this.updateSnapshot()
       },
       selectedTaskType() {
           this.updateSnapshot()
       },
       selectedTaskTypes() {
           this.updateSnapshot()
       },
       selectedOrder() {
           this.updateSnapshot()
       }
    },
    mounted: function () {
        this.updateSnapshot()
    },
    beforeUnmount: function () {
        this.hideSnapshot()
    },

    methods: {
        updateSnapshot() {
            if (this.selectedContract || (this.selectedContractIds && this.selectedContractIds.length > 0) || this.fromDate) {
                this.hideSnapshot()
                this.fetchRecords()
            }
        },

        fetchRecords: function () {
            if (!this.fetching && (this.selectedContractIds || this.selectedOrder)) {
                this.loading = true
                let searchParams = {}
                searchParams.from = this.fromDate
                searchParams.to = this.toDate
                if(this.selectedContractIds) {
                    searchParams.contracts = this.selectedContractIds
                }
                if(this.selectedTaskTypes && this.selectedTaskTypes.length > 0) {
                    searchParams.task_types = this.selectedTaskTypes.map(taskType => taskType.value);
                }
                if(this.selectedOrder) {
                    if (Array.isArray(this.selectedOrder)) {
                        searchParams.orders = this.selectedOrder
                    } else {
                        searchParams.orders = [this.selectedOrder]
                    }
                }
                this.restFetchParams(this.roadWorkRecordsUrl, searchParams, this.handleResponse, this.handleErrorResponse)
            }
        },

        handleResponse: function (response) {
            this.loading = false
            this.hideSnapshot()
            if (response) {
                this.results = response.data
                this.showSnapshot()
            }
        },

        handleErrorResponse(error) {
            this.loading = false
            this.fetching = false
            if (error.response && error.response.status && error.response.status === 500) {
                this.showAlert(this.$t('observations.err_too_much'))
            }
            this.timer = setTimeout(this.fetchVehicles, 10 * 60 * 1000); // Update every ten minutes
        },

        hideSnapshot: function () {
            this.map.removePolylinesByType(this.WORK_TRACE)
        },

        showSnapshot: function () {
            this.results.forEach(item => {
                // Draw trace
                if (item.geometry && item.geometry.points && item.geometry.points.length > 1) {
                    const points = item.geometry.points.map(([x, y]) => ({ x, y }));
                    this.map.drawPolyLine(item.id, this.WORK_TRACE, points, item.color, false, false, 3)
                }
            })
        },

        // eslint-disable-next-line
        showLabel: function (data, point) {
            // Find hovered geometry
            let streetName = ''
            let route = this.results.find(result => result.id === data.id)
            if (route) {
                let label = `<div class="nopads pl-2" style="font-style: italic; color: #949494">${route.task}</div>`
                label += `<div class="task-type-circle" style="background-color: ${this.getTraceColor(logModes.WORK, route.color)}"></div>
                      <span class="nopads">${this.toLocalTime(route.start_time)} - ${this.toLocalTime(route.end_time)}</span><br>`
                this.map.addGeoLabel(point.lat, point.lng, label, 'taskTypeLabel')
            }
        },

        showLabels: function (data, point) {
            // Find hovered geometry
            let label = '<div>'
            data.forEach(item => {
                if (item.lineData.type === this.WORK_TRACE) {
                    let route = this.results.find(result => result.id === item.lineData.id)
                    if (route) {
                        label += `<div class="nopads pl-2" style="font-style: italic; color: #949494">${route.task}</div>`
                        label += `<div class="task-type-circle" style="background-color: ${this.getTraceColor(logModes.WORK, route.color)}"></div>
                        <span class="nopads">${this.toLocalTime(route.start_time)} - ${this.toLocalTime(route.end_time)}</span><br>`
                    }
                }

            })
            label += '</div>'
            this.map.addGeoLabel(point.lat, point.lng, label, 'taskTypeLabel')
        },


        getTraceColor: function (mode, color) {
            if (mode === logModes.WORK) {
                return color
            }
            return '#bcbcbc'
        },

        hideLabel: function () {
            this.map.removeGeoLabels('taskTypeLabel')
        }
    }
}
</script>
